<template>
  <div>
    <v-form v-model="valid" ref="form" lazy-validation>
      <v-card-text class="pa-0" :style="{'overflow-y': (scrollable ? 'auto' : 'initial'), 'height': (typeof(height) == 'number' ? height+'px' : height)}">
        <v-layout class="pa-2" row wrap style="height: auto;" v-if="event">
          <v-flex xs6 style="padding-bottom: 5px;" pr-1>
            <v-layout row>
              <v-flex xs6>
                <v-autocomplete :disabled="disable_event_group_edit"  v-bind:items="sorted_inputs" v-model="event.event_group.channel_id" placeholder="Select source" clearable item-text="title" item-value="id" label="Source"></v-autocomplete>
                <template v-if="event.event_group.channel_id">
                  <v-layout row>
                    <v-flex xs6>
                      <v-autocomplete :items="alternatives" placeholder="Select alternative" label="Alternative" v-if="source_is_alternatives"
                     item-text="alternative" item-value="alternative" v-model="event.event_group.system_meta.alternative">
                    </v-autocomplete>
                    </v-flex>
                    <v-flex xs6>
                  <v-autocomplete :items="signal_types" v-if="source_is_signal_types" placeholder="Select signal type" label="Signal type" v-model="event.event_group.system_meta.signal_type" item-value="id" item-text="type">
                  </v-autocomplete>
                </v-flex>
                </v-layout>
                </template>
              </v-flex>
              <v-flex xs6>
                <v-autocomplete  v-bind:items="sorted_outputs" v-model="output" placeholder="Select destination" item-text="title" item-value="id" label="Destination" required :rules="[v => !!v || 'Item is required']"></v-autocomplete>
              </v-flex>
            </v-layout>
            <v-divider></v-divider>
            <component v-for="elem in left_side" :key="elem.name" v-bind:is="elem.type" v-bind="elem" v-model="event">
              <v-flex :class="row_classes(elem.childs)" v-for="celem in elem.childs" :key="celem.key">
                <component v-bind:is="celem.type" v-bind="celem" v-model="event"></component>
              </v-flex>
            </component>
          </v-flex>
          <v-flex xs6 style="padding-bottom: 5px;" pr-1>
            <v-layout row wrap>
              <v-flex xs6>
                <date-time-picker :disabled="disable_event_group_edit" label="Kickoff time" first-day-of-week="1" time-format="HH:mm" v-model="event.times.start_time"></date-time-picker>
              </v-flex>
              <v-flex xs6>
                <date-time-picker :disabled-before="event.times.start_time" label="End time" first-day-of-week="1" time-format="HH:mm" v-model="event.times.end_time" :time-buttons="time_buttons" :rules="end_time_validation_rules" :clear-time="!id" ref="end_time" :modified.sync="end_time_modified"></date-time-picker>
              </v-flex>
            </v-layout>
            <v-select :hint="'Duration: '+calculatedDuration" persistent-hint v-bind:items="beforeTimes" v-model="event.offset" item-value="value" item-text="label" label="Open Before"></v-select>
            <v-divider></v-divider>
            <v-layout row wrap>
              <v-flex xs6>
                <date-time-picker label="Publish start" first-day-of-week="1" time-format="HH:mm" v-model="event.times.publish_start_time"></date-time-picker>
              </v-flex>
              <v-flex xs6>
                <date-time-picker :disabled-before="event.times.publish_start_time" label="Publish end" first-day-of-week="1" time-format="HH:mm" v-model="event.times.publish_end_time" :time-buttons="publish_time_buttons" :modified.sync="publish_end_time_modified"></date-time-picker>
              </v-flex>
            </v-layout>

            <v-layout row wrap v-if="$is_admin() && event">
              <v-flex xs4>
                <contract-select v-model="event.system_meta.billing" name="contract" label="Billing contract" v-bind:output_channel="output_channel"></contract-select>
              </v-flex>
              <v-flex xs4>
                <v-autocomplete v-model="event.system_meta.billing.status" name="billing_status" label="Billing status" placeholder="Billing status" :items="billing_statuses" item-text="label" item-value="value">
                </v-autocomplete>
              </v-flex>
              <v-flex xs4>
                <v-text-field v-model="event.system_meta.billing.sum" label="Billing sum" placeholder="Billing sum" type="number"></v-text-field>
              </v-flex>
              <v-flex xs4>
                <v-text-field v-model="event.system_meta.billing.expenses_sum" label="Expenses sum" placeholder="Expenses sum" type="number"></v-text-field>
              </v-flex>
 
            </v-layout>
            <v-layout v-if="$is_admin()">
              <v-flex>
                <text-area v-model="event.system_meta.billing" name="info" label="Billing information" title="Billing information"></text-area>
              </v-flex>
            </v-layout>

            <v-layout row wrap v-if="current_account_email && $is_admin()"> 
              <v-flex xs6>
                <v-checkbox label="Todo list" v-model="todo"></v-checkbox>
              </v-flex>
              <v-flex xs6>
                <v-autocomplete placeholder="Todo status" label="Todo status" :items="todo_statuses" v-model="todo_status">
                </v-autocomplete>
              </v-flex>
            </v-layout>


            <component v-for="elem in right_side" :key="elem.name" v-bind:is="elem.type" v-bind="elem" v-model="event">
              <v-flex :class="row_classes(elem.childs)" v-for="celem in elem.childs" :key="celem.key">
                <component v-bind:is="celem.type" v-bind="celem" v-model="event"></component>
              </v-flex>
            </component>
            <v-divider v-if="id"></v-divider>
            <v-text-field
              label="UUID"
              :value="id"
              readonly
              v-if="id"
            ></v-text-field>
            <v-text-field
              label="Recording UUID"
              :value="event.event_group.uuid"
              readonly
              v-if="id && $is_admin()"
            ></v-text-field>
            <v-text-field
              label="External Id"
              :value="event.external_id"
              readonly
              v-if="event.external_id"
            ></v-text-field>
            <p v-if="page_url">
              Page url: <a :href="page_url" target="_blank">{{page_url}}</a>
            </p>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn flat @click="reset">Reset</v-btn>
        <v-btn color="error" v-show="is_edit && event.state != 'archived'" @click="changeState('archived')">Archive</v-btn>
        <v-btn color="error" v-show="is_edit && event.state == 'archived'" @click="changeState('active')">Unarchive</v-btn>
        <v-btn color="info" v-show="is_edit && !disable_event_group_edit" @click="clone()">Clone</v-btn>
        <v-btn color="success" v-show="!disable_event_group_edit" @click="save('none')">Save</v-btn>
        <v-btn color="success" v-show="is_edit && disable_event_group_edit" @click="save('none')">Save</v-btn>
        <v-btn color="success" v-show="!is_edit && disable_event_group_edit" @click="save('new')">Save</v-btn>
        <v-btn color="success" v-show="!is_edit && !disable_event_group_edit" @click="save('new')">Save and new</v-btn>
        <v-btn color="success" v-show="!disable_event_group_edit" @click="save('close')">Save and close</v-btn>
      </v-card-actions>
    </v-form>
  </div>
</template>

<script>
import moment from 'moment';
require("moment-duration-format");


import * as FormItems from '@/components/form_items'
import { mapGetters } from 'vuex'
import ChannelModel from '@/models/channel.js'
import EventModel from '@/models/event.js'
import SettingsModel from '@/models/settings.js'
import DateTimePicker from '../../DateTimePicker';
import DatePicker from '../../DatePicker';
import Vue from 'vue';
import TextArea from '../../form_items/TextArea.vue';

export default {
  props: {
    id: null,
    event_group: null,
    scrollable: {
      type: Boolean,
      default: true
    },
    height: {
      type: [Number, String],
      default: 532
    },
    disable_event_group_edit: {
      type: Boolean,
      default: false
    },
    disable_get_profile: {
      type: Boolean,
      default: false
    }
  },
  components: 
    {
    TextArea,
    DateTimePicker,
    DatePicker,
    ...FormItems
    },
  data () {
    var ch = this.$cloudserver.channel(this.get_channel(this.$route));
    return {
      valid: true,
      ws_channel: ch,
      event: this.convertEvent(ch.data),
      output: _.get(ch, "data.channel_id"),
      beforeTimes: EventModel.before_times(),
      todo_statuses: ["watch","ready"],
      billing_statuses: [
        {label: "Billed", value: "billed"},
        {label: "Not billed", value: "not_billed"}
      ],
      current_account: undefined,
      time_buttons: [
        {text: "3H", value: 3*60*60, action: "add", to: () => { return this.event.times.start_time }},
        {text: "6H", value: 6*60*60, action: "add", to: () => { return this.event.times.start_time }},
        {text: "12H", value: 12*60*60, action: "add", to: () => { return this.event.times.start_time }}
      ],
      publish_time_buttons: [
        {text: "End of kickoff day", icon: "keyboard_tab", action: "end_of_day", to: () => { return this.event.times.start_time }},
      ],
      end_time_validation_rules: [
        (value) => { 
          if (this.event.times.start_time && value) {
            if (moment(this.event.times.start_time).isSameOrAfter(value)) {
              return "End time must be after start time!";
            }
          }
          return true;
        }
      ],
      end_time_modified: false,
      publish_end_time_modified: false
    }
  },
  watch: {
    "ws_channel.data": {
      handler(newVal, oldVal) {
        if(typeof(newVal) != "undefined") this.event = this.convertEvent(newVal, oldVal);
      },
      deep: true
    },
    '$route' (to, from) {
      if((typeof(from.meta.edit) != "undefined" && to.name == from.meta.edit) || (typeof(from.meta.new) != "undefined" && to.name == from.meta.new)) {
        console.log(this.get_channel(to))
        this.ws_channel = this.$cloudserver.channel(this.get_channel(to));
        this.ws_channel.join();
      }
    },
    "event.times.start_time" (newVal, oldVal) {
      if(newVal != oldVal && oldVal && this.event) {
        if(!this.end_time_modified) {
          this.event.times.end_time = moment(newVal).add((moment(this.event.times.end_time).unix() - moment(oldVal).unix()),"seconds").toDate();
        } else {
          this.$refs.end_time.validate();
        }
        if(!this.publish_end_time_modified && moment(this.event.times.publish_end_time).unix() != 0) this.event.times.publish_end_time = moment(newVal).add((moment(this.event.times.publish_end_time).unix() - moment(oldVal).unix()),"seconds").toDate();
      }
    },
    "$store.state.account": {
      handler(newVal, oldVal) {
        if(typeof(newVal) == "object" && typeof(newVal.meta) == "object" && typeof(newVal.meta.default_destination) != "undefined" && !this.output && !this.is_edit) {
          var channel = ChannelModel.channel_by_uuid(newVal.meta.default_destination);
          if(typeof(channel) == "object") {
            this.output = channel.id;
          }
        }
        if (typeof(newVal) == "object") {
          this.current_account = newVal;
        }
      },
      deep: true
    }
  },
  created() {
    this.ws_channel.join();
    if(!this.disable_get_profile) this.$store.dispatch("get_profile");
  },
  computed: {
    is_edit () {
      return typeof(this.event) != "undefined" && this.event.uuid != null;
    },
    form () {
      var channel = ChannelModel.get_channel(this.output);
      if(!channel) return [];
      return (SettingsModel.get_by_name(channel.meta.event_form)||{}).value || {};
    },
    left_side () {
      return this.form.left
    },
    right_side () {
      return this.form.right
    },
    page_url () {
      if(!this.id) return;
      return EventModel.page_url(this.event)
    },
    calculatedDuration () {
      var val = this.calcDuration - this.event.offset;
      if(val < 0) return "-";
      return moment.duration(val, "seconds").format("h [hrs], m [min]")
    },
    calcDuration () {
      return moment(this.event.times.end_time).unix() - moment(this.event.times.start_time).unix()
    },
    sorted_inputs() {
      return _.sortBy(_.filter(this.inputs, (input) => { return input.state == "active"; }), "title");
    },
    sorted_outputs() {
      return _.sortBy(_.filter(this.outputs, (output) => { return output.state == "active"; }), "title");
    },
    output_channel() {
      return _.filter(this.outputs, (out) => { return out.id == this.output; });
    },

    alternatives () {
      if (this.source_is_alternatives == false) return [];
      var channel_id = this.event.event_group.channel_id;
      var channel = ChannelModel.channel_by_id(channel_id);
      var outputs = ChannelModel.outputs_list(channel);

      return _.filter(outputs, (output) => {
            return typeof(output.alternative) != "undefined";
      });
    },

    source_is_alternatives() {
      var outputs = this.source_outputs;      
      if (typeof(outputs) != "undefined") {
        var alternatives = _.filter(outputs, (output) => {
          return typeof(output.alternative) != "undefined";
        });
        if (alternatives.length > 0) return true;
      }
      return false;
    },

    signal_types () {
      if (this.source_is_signal_types == true) {
        if (typeof(this.event.event_group.system_meta.alternative) != "undefined" && this.event.event_group.system_meta.alternative != null) {
          var selected_alt = _.find(this.alternatives, (output) => {
            return output.alternative == this.event.event_group.system_meta.alternative;
          });
          if (selected_alt.type == "signal-select") {
            var data = SettingsModel.get_by_name(selected_alt.settings_name)||{};
            return data.value.signals||[];
          } else {
            return [];
          }
        } else {
        
          var outs = _.filter(this.source_outputs, (out) => {
            return (out.type == "signal-select");
          });
        
          if (outs.length == 1) {
            var out = outs[0];

            if (out.type == "signal-select") {
              var data = SettingsModel.get_by_name(out.settings_name)||{};
              return data.value.signals||[];;
            }
          }
        }
      }
      return [];
    },

    source_is_signal_types() {
      if (this.source_is_alternatives == true) {
        if (typeof(this.event.event_group.system_meta.alternative) != "undefined" && this.event.event_group.system_meta.alternative != null) {
          var selected_alt = _.find(this.alternatives, (output) => {
            return output.alternative == this.event.event_group.system_meta.alternative;
          });
          if (typeof(selected_alt) != "undefined") {
            if (selected_alt.type == "signal-select") return true;
          }
          return false;
        } else {
          return false;
        }
      } else {

        var outs = _.filter(this.source_outputs, (out) => {
          return (out.type == "signal-select");
        });

        if (outs.length > 1) {
          // HIRVEÄ ALERTTI
          return false;
        }
        if (outs.length == 1) {
          return true;
        }

        return false;
      }

      return false;
    },

    source_outputs () {
      var channel = ChannelModel.channel_by_id(this.event.event_group.channel_id);
      if (typeof(channel) == "undefined") return [];
      if (typeof(channel.configuration.output) != "undefined") {
        return ChannelModel.outputs_list(channel);
      }
      return [];
    },

    current_account_email () {
      if (typeof(this.current_account) != "undefined") {
        return this.current_account.email;
      }
      return undefined;
    },

    todo: {
      get: function() {
        return EventModel.is_todo_list(this.event, this.current_account);
      },
      set: function(newValue) {
        this._check_todo_data();
        Vue.set(this.event.event_group.system_meta.todos[this.current_account_email],'active', newValue);
      }
    },
    todo_status: {
       get: function() {
        return EventModel.todo_list_status(this.event, this.current_account);
      },
      set: function(newValue) {
        this._check_todo_data();
        Vue.set(this.event.event_group.system_meta.todos[this.current_account_email],'status', newValue);
      }
    },

    ...mapGetters({
      outputs: 'output_channels',
      inputs: 'input_channels'
    })
  },
  methods: {
   _check_todo_data() {
        if (typeof(this.event.event_group.system_meta) == "undefined" || this.event.event_group.system_meta == null) {
          Vue.set(this.event.event_group, "system_meta", {});
        }
        if (typeof(this.event.event_group.system_meta.todos) == "undefined") {
          Vue.set(this.event.event_group.system_meta, "todos", {});
        }
        if (typeof(this.event.event_group.system_meta.todos[this.current_account_email]) == "undefined")
        {
          Vue.set(this.event.event_group.system_meta.todos, this.current_account_email, {}); 
        }
    },
    get_channel (route) {
      var clone_id = route.query.clone_id;
      return "events:"+(this.id||(clone_id ? "clone:"+clone_id : (this.event_group ? "create_with_group:"+this.event_group : "create" )));
    },
    convertEvent: function(newVal, oldVal) {
      var event = _.cloneDeep(newVal);
      if(typeof(oldVal) != "undefined") {
        //TODO: Tähän muuttuneen datan tarkistus ja ilmoitus
      }

      if (typeof(event) == "undefined" || _.isEmpty(event)) return undefined;
      var start_time = moment.unix(event.event_group.start_time).toDate();
      if (!_.isEmpty(this.id)) {
        var end_time = moment.unix((event.cached_end_time || (event.event_group.start_time+event.duration))).toDate();
      } else {
        var end_time = start_time;
      }
      
      var publish_start_time = moment.unix(event.publish_start_time).toDate();
      var publish_end_time = moment.unix(event.publish_end_time).toDate();

      event.times = {
        "start_time": start_time,
        "end_time": end_time,
        "publish_start_time": publish_start_time,
        "publish_end_time": publish_end_time
      }
      this.output = event.channel_id;

      if (_.isEmpty(event.system_meta)) {
        event.system_meta = {};
      }

      if (_.isEmpty(event.system_meta.billing)) {
        event.system_meta.billing = {};
      }


      return event;
    },
    row_classes(childs) {
      return "xs" + Math.round(12/childs.length);
    },
    reset () {
      this.event = this.convertEvent(this.ws_channel.data);
    },
    changeState (state) {
      this.event.state = state;
      this.save(false);
    },
    clone () {
      this.$router.push({name: this.$route.meta.new, query: {...this.$route.query, clone_id: this.id}})
    },
    save (type) {
      if (!this.$refs.form.validate()) {
        return;
      }
      if (!this.$refs.end_time.validate()) {
        return;
      }
      if(typeof(this.ws_channel) != "undefined") {

        var self = this;
        var event = _.cloneDeep(this.event);

        if(!this.output) {
          if (typeof(event.uuid) == "undefined" || event.uuid == null) {
            self.$message.warning("Unable to create event. Destination missing!");
          } else {
            self.$message.warning("Unable to update event. Destination missing!");
          }
          return;
        }

        if(typeof(event.event_group.channel_id) == "undefined") event.event_group.channel_id = null;
        event.event_group.events = null;
        event.event_group.start_time = moment(this.event.times.start_time).unix()
        event.publish_start_time = moment(this.event.times.publish_start_time).unix()
        event.publish_end_time = moment(this.event.times.publish_end_time).unix()
        event.duration = this.calcDuration;
        event.channel_id = this.output;

        delete event.times;

        this.ws_channel.save({event: event}, (type != "new"))
          .then((msg) => {
            if (typeof(event.uuid) == "undefined" || event.uuid == null) {
              self.$message.success("Event was created!");
            } else {
              self.$message.success("Event was updated!");
            }
            if(type == "close") {
              self.$root.close_bottom_sheet();
            } else if (type == "new") {
              self.reset();
            } else if(typeof(this.id) == "undefined" && typeof(this.$route.meta.edit) != "undefined") {
              this.$router.push({name: this.$route.meta.edit, params: {id: msg.data.uuid}})
            }
          })
          .catch((msg) => {
            console.log(msg);
            if (typeof(event.uuid) == "undefined" || event.uuid == null) {
              self.$message.warning("Unable to create event!");
            } else {
              self.$message.warning("Unable to update event!");
            }
          });
      }
    }
  }
}
</script>
